import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { MatureDeviationContext } from '../../Context/MatureDeviationContext';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType, getShouldDisplayPaywall } from '../_helpers';
import HiddenOverlay from '../HiddenOverlay';
import FolderPaywallFullView from './_partials/FolderPaywall';
import ImageFullView from './Image';
import FilmFullView from './Film';
import JournalFullView from './Journal';
import LiteratureFullView from './Literature';
import PdfFullView from './Pdf';
import PollFullView from './Poll';
import StatusFullView from './Status';
import CommissionFullView from './Commission';
import TierFullView from './Tier';
import UnknownFullView from './Unknown';
import SubPaywall from './_partials/SubPaywall';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { overrideSubscribeMatureFilter } from '../../Tier/redux/consumer/actions';
const DeviationFullView = (props)=>{
    var _deviation;
    const dispatch = useDispatch();
    const { deviation } = props;
    const deviationType = getDeviationType(deviation);
    const { isSubscribedButBlocked, needsSubscription } = useSubscriptionTier(props.deviation);
    const { showBlocked, overrideMatureFilter } = useContext(MatureDeviationContext);
    const overrideMatureFilterWrapper = useCallback(()=>{
        if (deviationType === DeviationTypes.TIER) {
            dispatch(overrideSubscribeMatureFilter(deviation));
        }
        overrideMatureFilter();
    }, [
        overrideMatureFilter,
        dispatch,
        deviation,
        deviationType
    ]);
    if (showBlocked) {
        return /*#__PURE__*/ React.createElement(HiddenOverlay, _object_spread({
            overrideMatureFilter: overrideMatureFilterWrapper
        }, props));
    }
    const { isPremiumLocked } = normalizePremiumFolderData((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.premiumFolderData);
    if (isPremiumLocked && deviationType !== DeviationTypes.LITERATURE) {
        return /*#__PURE__*/ React.createElement(FolderPaywallFullView, props);
    }
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    if (isBlocked && getShouldDisplayPaywall(deviationType)) {
        return /*#__PURE__*/ React.createElement(SubPaywall, _object_spread_props(_object_spread({}, props), {
            showImage: true
        }));
    }
    switch(deviationType){
        case DeviationTypes.IMAGE:
            return /*#__PURE__*/ React.createElement(ImageFullView, props);
        case DeviationTypes.FILM:
            return /*#__PURE__*/ React.createElement(FilmFullView, props);
        case DeviationTypes.PDF:
            return /*#__PURE__*/ React.createElement(PdfFullView, props);
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(LiteratureFullView, props);
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalFullView, props);
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(StatusFullView, props);
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(PollFullView, props);
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionFullView, props);
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierFullView, props);
        default:
            return /*#__PURE__*/ React.createElement(UnknownFullView, _object_spread_props(_object_spread({}, props), {
                type: deviationType
            }));
    }
};
export default DeviationFullView;
